module.exports = __webpack_public_path__ + "static/img/02003C_6_I_20230710_LC.23b61a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02003C_6_I_20230710_LC.png
// module id = uwaV
// module chunks = 0